export default "__VITE_ASSET__6cd3bbce__"